
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/addPreset/addSection/components/addSectionContextMenu.scss.css.virtualfile';
        module.exports = {"contextMenu":"_contextMenu_bg7jf_7","contextMenuSymbol":"_contextMenuSymbol_bg7jf_14"};